import getBuyerDomain from "./getBuyerDomain";

const buildLinkUrl = (url: string, isToUseAuthZero = false) => {
  const apiUrl = new URL(url);
  const apiProtocol = apiUrl.protocol;
  const apiHost = apiUrl.host;
  let buyerAPIDomain = getBuyerDomain(isToUseAuthZero).toString();

  if (buyerAPIDomain.substring(buyerAPIDomain.length - 1) === "/") {
    buyerAPIDomain = buyerAPIDomain.slice(0, -1);
  }

  const newUrl = url.replace(`${apiProtocol}//${apiHost}`, buyerAPIDomain);
  return newUrl;
};

export default buildLinkUrl;
